
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/thjonusta/uthringiverkefni",
      function () {
        return require("private-next-pages/um/thjonusta/uthringiverkefni.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/thjonusta/uthringiverkefni"])
      });
    }
  